import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component, inject } from 'intact-vue';
import template from './template.vdt';
import { addStyle } from '../utils';
import { makeHeaderStyles, themes } from './styles';
import { defaultHeight, ROOT_LAYOUT, getStyle } from './helpers';
import { useConfigContext } from '../config';
var typeDefs = {
  fixed: Boolean,
  height: [Number, String],
  style: [String, Object],
  theme: themes,
  blur: Boolean,
  boxShadow: Boolean
};
var defaults = function defaults() {
  return {
    height: defaultHeight,
    theme: 'dark'
  };
};
export var Header = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Header, _Component);
  function Header() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.rootLayout = inject(ROOT_LAYOUT);
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Header.prototype;
  _proto.getClassNames = function getClassNames() {
    var _ref;
    var _this$get = this.get(),
      className = _this$get.className,
      fixed = _this$get.fixed,
      theme = _this$get.theme,
      blur = _this$get.blur,
      boxShadow = _this$get.boxShadow;
    var k = this.config.k;
    return _ref = {}, _ref[k + "-layout-header"] = true, _ref[k + "-fixed"] = fixed, _ref[k + "-blur"] = blur, _ref[k + "-box-shadow"] = boxShadow, _ref[k + "-" + theme] = true, _ref[className] = className, _ref[makeHeaderStyles(k)] = true, _ref;
  };
  _proto.getStyles = function getStyles() {
    var _this$get2 = this.get(),
      style = _this$get2.style,
      height = _this$get2.height;
    var _this$rootLayout$pars = this.rootLayout.parse(),
      hasFixedAside = _this$rootLayout$pars.hasFixedAside,
      asideWidth = _this$rootLayout$pars.asideWidth;
    return addStyle(style, {
      height: getStyle(height),
      left: hasFixedAside ? getStyle(asideWidth) : null
    });
  };
  return Header;
}(Component);
Header.template = template;
Header.typeDefs = typeDefs;
Header.defaults = defaults;